export const deClientPortalValuationPlausibilityPage = {
    panels: {
        pdf: {
            title: 'Gutachtenentwurf PDF',
        },
        annotations: {
            title: 'Anmerkungen',
        },
    },
    textBubble: {
        actions: {
            edit: 'Bearbeiten',
            deleteAnnotation: 'Anmerkung löschen',
            deleteThread: 'Ganze Kette löschen',
            delete: 'Löschen',
            cancel: 'Abbrechen',
            reply: 'Antworten',
            close: 'Schließen',
        },
        unknownUser: 'Unbekannt',
        createdInDraft: 'Erstellt in Entwurf {{draftVersion}}',
        editAnnotationPlaceholder: 'Anmerkung schreiben',
        editReplyPlaceholder: 'Antwort schreiben',
        createAnnotationPlaceholder: 'Anmerkung schreiben...',
        createReplyPlaceholder: 'Antwort schreiben...',
        deletedAnnotation: 'Diese Anmerkung wurde gelöscht.',
        edited: 'bearbeitet',
        deleteModalTitle: 'Anmerkung löschen',
        deleteConfirmation: 'Sind Sie sicher, dass Sie diese Anmerkung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteConfirmationWithReplies:
            'Sind Sie sicher, dass Sie diese Anmerkung (und alle Antworten) löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        notificationTooltip: 'Die Kundin/der Kunde wird über neue Anmerkungen im Tagesbericht informiert.',
        immediatelyVisible: 'Anmerkung sofort sichtbar für Gutachter/in',
    },
    userLink: {
        me: 'Ich',
        external: 'Extern',
        unknown: 'Nicht festgelegt',
        contact: 'Kontakt',
        editOwnContactTooltip: 'Eigene Kontaktdaten bearbeiten',
        emailCopied: 'Email-Adresse kopiert',
        phoneCopied: 'Telefonnummer kopiert',
        addressCopied: 'Adresse kopiert',
        note: 'Anmerkung',
        externalEmailInfo: 'Dieser Kontakt kollaboriert über E-Mail.',
    },
}
